let contentful = require('contentful');

export function itemsHasErrored(bool) {
    return {
        type: 'ITEMS_HAS_ERRORED',
        hasErrored: bool
    };
}
export function itemsIsLoading(bool) {
    return {
        type: 'ITEMS_IS_LOADING',
        isLoading: bool
    };
}

export function StatusSuccess(status) {
    return {
        type: 'STATUS_SUCCESS',
        status
    };
}

export function SystemsSuccess(systems) {
    return {
        type: 'SYSTEM_SUCCESS',
        systems
    };
}
export function IncidentsSuccess(incidents) {
    return {
        type: 'INCIDENTS_SUCCESS',
        incidents
    };
}

export function GeneralContentSuccess(generalContent) {
    return {
        type: 'GENERAL_CONTENT_SUCCESS',
        generalContent
    };
}

const client = contentful.createClient({
    space: 'k21ka8pcl5lx',
    accessToken: 'dc8bc8fe3565088b5d7bf6ad274b6ff086ddf9b18f16b21bdbad5ce9dc858400'
});

export function Status() {
    return (dispatch) => {
        dispatch(itemsIsLoading(true));

        client.getEntries({content_type: 'status',
        order: 'sys.id'})
            .then((response) => {
                dispatch(itemsIsLoading(false));
                return response;
            })
            .then((items) => dispatch(StatusSuccess(items)))
            .catch(console.error);
    };
}

export function Systems() {
    return (dispatch) => {
        dispatch(itemsIsLoading(true));

        client.getEntries({content_type: 'systems'})
            .then((response) => {

                dispatch(itemsIsLoading(false));
                return response;
            })
            .then((items) => dispatch(SystemsSuccess(items)))
            .catch(console.error);
    };
}

export function Incidents() {
    return (dispatch) => {
        dispatch(itemsIsLoading(true));

        client.getEntries({content_type: 'incidents'
            // 'fields.openDate[lte]': today

        })
            .then((response) => {

                dispatch(itemsIsLoading(false));
                return response;
            })
            .then((items) => dispatch(IncidentsSuccess(items)))
            .catch(console.error);
    };
}

export function GeneralContent() {
    return (dispatch) => {
        dispatch(itemsIsLoading(true));

        client.getEntries({content_type: 'generalContent'})
            .then((response) => {

                dispatch(itemsIsLoading(false));
                return response;
            })
            .then((items) => dispatch(GeneralContentSuccess(items)))
            .catch(console.error);
    };
}




// WEBPACK FOOTER //
// ./src/Redux/ContentfulContentGrabber.js